var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var indicator = require('ordinal/indicator');
var stable = require('stable');
var slugify = require('../utils/slugify.js');

function IssueRankings(el) {
  var $el = $(el),
      $rankings = $el.find('#issue-rankings'),
      $sort = $el.find('#issue-sort'),
      $shortname = $sort.find('.active').attr('data-val'),
      $companyCount = $el.attr('data-company-count'),
      $link = $el.find('#explorer-link'),
      $companyData = '/wp-content/themes/justcapital/assets/data/companies.json',
      $industryData = '/wp-content/themes/justcapital/assets/data/industries.json',
      $companies,
      $industries = {},
      $prevIssueScore = '',
      $tieRank = null;

  if ($(window).width() >= 960) $sort.removeClass('custom-select');

  $.getJSON($companyData, function(data) {
    $companies = data;
    showRankings();
  });

  $.getJSON($industryData, function(industries) {
    for (var i = 0; i < industries.length; i++) {
      var industry = industries[i];
      $industries[industry.name] = industry.total;
    }
  });

  $(window).resize(function() {
    if ($(window).width() >= 960) {
      $sort.removeClass('custom-select');
    } else {
      $sort.addClass('custom-select');
    }
  });

  $sort.click(function(e) {
    e.stopPropagation();
  });

  $sort.on('click', 'p', function() {
    // Expand dropdown options
    $sort.children('.component-sort').hide();
    $(this).next().show();
  }).on('click', 'a', function(e) {
    e.preventDefault();
    $shortname = $(this).attr('data-val');
    $rankings.removeClass('visible').empty();
    $sort.find('.custom-select-label').text($(this).text());
    $sort.find('.active').removeClass('active');
    $(this).addClass('active');
    if ($(window).width() < 960) $sort.children('.component-sort').hide();
    if ($(window).width() >= 960) {
      if ($(this).next().hasClass('metric-sort')) {
        $sort.find('.metric-sort').removeClass('exposed');
        $(this).next().addClass('exposed');
      }
    }
    showRankings();
    var filterLink = '/rankings?issue=' + $shortname.split('.')[0];
    if ($shortname.split('.')[1] !== 'overall') filterLink += '&component=' + $shortname.split('.')[1];
    if ($shortname.split('.')[2] !== 'overall') filterLink += '&metric=' + $shortname.split('.')[2];
    $link.attr('href', filterLink);
  });

  function showRankings() {
    function sort(x,y) {
      var issueKey = $shortname.split('.')[0],
          componentKey = $shortname.split('.')[1],
          metricKey = $shortname.split('.')[2];
      if (componentKey === 'overall') {
        return y.scores[issueKey][componentKey] - x.scores[issueKey][componentKey];
      } else {
        return y.scores[issueKey][componentKey][metricKey] - x.scores[issueKey][componentKey][metricKey];
      }
    }
    stable.inplace($companies, sort);
    var $topCompanies = '',
    $issueScore=null, 
    $tieRank=null, 
    $prevIssueScore=null,
    $index=0;
    for (var i = 0; i < $companyCount; i++) {
      var company = $companies[i],
          $index = i + 1,
          $rank = parseInt(company.rank.overall),
          $rankText = $rank ? '<span class="rank">' + $rank + '<span class="hidden-lg">' + indicator($rank) + ' overall</span></span>' : '<span class="rank--bottom">Bottom 10%</span>',
          $industry = company.industry,
          $industryRank = parseInt(company.rank.industry),
          $link = '/companies/' + slugify(company.name),
          $just100 = ($rank && $rank <= 100) ? '<p class="seal"><span><strong>JUST 100</strong> ' + $el.attr('data-year') + '</span></p>' : '',
          $industryLeader = ($industryRank === 1) ? '<p class="seal"><span><strong>Industry Leader</strong> ' + $el.attr('data-year') + '</span></p>' : '',
          $nextScore=null;

      if ($shortname.split('.')[1] === 'overall') {
        $issueScore = company.scores[$shortname.split('.')[0]][$shortname.split('.')[1]];
      } else {
        $issueScore = company.scores[$shortname.split('.')[0]][$shortname.split('.')[1]][$shortname.split('.')[2]];
      }
      if ($issueScore === $prevIssueScore && $index !== 1)
      {
        if (!$tieRank)
        {
          $tieRank = $prevIssueScore ? $index - 1 : $index;
        }
        $index = $tieRank;
      } else {

        if(i < $companyCount)
        {
          if ($shortname.split('.')[1] === 'overall') {
            $nextScore = $companies[i+1].scores[$shortname.split('.')[0]][$shortname.split('.')[1]];
          } else {
            $nextScore = $companies[i+1].scores[$shortname.split('.')[0]][$shortname.split('.')[1]][$shortname.split('.')[2]];
          }
          if($issueScore==$nextScore)
          {
            $tieRank = ($tieRank)?$tieRank:$index;
          }
          else
          {
            $tieRank = null;
          }
        }
        else
        {
          $tieRank = null;
        }
        
      }

      



      $prevIssueScore = $issueScore;

      var $tieLabel = ($tieRank) ? '<span class="rank--label">Tied</span>' : '';

      $topCompanies += '<li><a class="rankings__content" href="' + $link + '"><p class="rankings__left-col">' + $tieLabel + '<span class="rank">' + $index + '</span></p><p class="rankings__logo"><img src="/wp-content/themes/justcapital/assets/img/company-logos/' + company.ticker + '.png" alt="" /></p><div><div class="rankings__company"><p>' + company.name + '</p><p>' + $industry + '</p></div><div class="rankings__seals"><div class="rankings__seal rankings__seal--100">' + $just100 + '</div><div class="rankings__seal rankings__seal--industry">' + $industryLeader + '</div></div><p class="rankings__right-col">' + $rankText + '</p><p class="rankings__button"><span>View Details</span></p></div></a></li>';
    }
    $rankings.append($topCompanies).ready(function () {
      $rankings.addClass('visible');
    });
  }

}

module.exports = IssueRankings;
